import React, { useEffect, useRef, useState } from "react";
import { Card, Col, Row, Tag, Tooltip } from "antd";
// import './../info-card.css';
import moment from "moment";
import TaskService from "../../../services/TaskService";
// import TaskDetail from '../../Task/TaskDetail';
import TaskDetail from "../../ProspectCustomerDetail/Tasks/TaskDetailCustomer";

// interface InfoCardProps {
//   count: string;
//   title: string;
//   description: string;
// }

const Tasks: React.FC<any> = ({ dateRange }) => {
  const [tasks, setTasks] = useState<any>([]);
  // const userId = localStorage.getItem("id");
  const roleName = localStorage.getItem("roleName");
  const prevDateRangeRef = useRef();

  // const filteredTasksCount = tasks?.filter(
  //   (task: any) => task?.assignee.id == userId || task?.reporter.id == userId
  // ).length;

  const getTasks = () => {
    const prevDateRange = prevDateRangeRef.current;

    const [startDate, endDate] = dateRange;

    let formattedDateRange;
    if (startDate && endDate) {
      formattedDateRange = `?startDueDate=${startDate}T00:00:00&endDueDate=${endDate}T23:59:59`;
    }

    if (startDate === undefined || endDate === undefined) {
      return;
    }
    if (
      prevDateRange?.[0] !== dateRange?.[0] ||
      prevDateRange?.[1] !== dateRange?.[1]
    ) {
      if (roleName === "CALL_TEAM") {
        TaskService.getAllMyTask(formattedDateRange)
          .then((response: any) => {
            let taskData = response.data;
            const todoTasks = taskData.filter(
              (item: any) => item.status === "TODO"
            );
            const reversedTodoTasks = [...todoTasks].reverse();
            setTasks(reversedTodoTasks);
          })
          .catch((e: Error) => {
            console.log(e);
          });
      } else if (roleName === "CALL_TEAM_MANAGER") {
        TaskService.getAllUsers(formattedDateRange)
          .then((response: any) => {
            let taskData = response.data;
            const todoTasks = taskData.filter(
              (item: any) => item.status === "TODO"
            );
            const reversedTodoTasks = [...todoTasks].reverse();
            setTasks(reversedTodoTasks);
          })
          .catch((e: Error) => {
            console.log(e);
          });
      }
    }
    prevDateRangeRef.current = dateRange;
  };

  useEffect(() => {
    getTasks();
    // eslint-disable-next-line
  }, [dateRange]);

  return (
    <Card bordered={false} className={"tasks-card"}>
      <div
        className="title"
        style={{ color: "#EEC73B", fontSize: 22, fontWeight: 600 }}
      >
        Tasks & Reminders
      </div>
      <p className="description">{tasks.length} Tasks</p>
      {/* {filteredTasksCount} */}
      <div
        className="tasks-container dashboard-card"
        style={{
          height:
            roleName === "CALL_TEAM_MANAGER"
              ? "405px"
              : "180px",
          overflow: "auto",
        }}
      >
        <Row justify="space-between" align="middle" className="note-row-title">
          <Col span={3} className="note-table-title">
            Status
          </Col>
          <Col span={5} className="note-table-title">
            Full Name
          </Col>
          <Col span={7} className="note-table-title">
            Title
          </Col>
          <Col span={5} className="note-table-title">
            Due Date
          </Col>
          <Col span={4} className="note-table-title"></Col>
        </Row>
        {tasks?.map((item: any) => (
          <>
            {/* {item.assignee.id == userId || item.reporter.id == userId ? */}
            <Row
              align="middle"
              className="rowItem"
            >
              <Col span={3}>
                <Tag
                  color="orange"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "32px",
                    minWidth: "42px",
                  }}
                >
                  {item.status}
                </Tag>
              </Col>
              <Col span={5}>
                <div>
                  <Tooltip
                    title={
                      item?.learner
                        ? `${item?.learner?.firstName} ${item?.learner?.lastName}`
                        : item?.customer?.fullName
                    }
                  >
                    <p
                      style={{
                        fontSize: 12,
                        fontWeight: "600",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "12ch",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {item?.learner
                        ? `${item?.learner?.firstName} ${item?.learner?.lastName}`
                        : item?.customer?.fullName}
                    </p>
                  </Tooltip>
                </div>
              </Col>
              <Col
                span={7}
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                <Row>
                  <Tooltip
                    title={
                      <>
                        {item.title}
                        <br />
                        {item.description ?? ""}
                      </>
                    }
                  >
                    <p
                      style={{
                        fontSize: 12,
                        fontWeight: "500",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "18ch",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {item.title}
                    </p>
                  </Tooltip>
                </Row>
              </Col>
              <Col span={5}>
                <Row>
                  <div>
                    <p style={{ fontSize: 12, fontWeight: "500" }}>
                      {moment(item.dueDate).format("DD/MM/YYYY")}
                    </p>
                  </div>
                </Row>
              </Col>
              <Col span={4}>
                {/* <Button type="primary" style={{ float: 'right' }}>
                                    Detail
                                </Button> */}
                <TaskDetail
                  item={item}
                  getTasks={getTasks}
                  onHandleTaskList={() => undefined}
                />
              </Col>
            </Row>
            {/* : null */}
            {/* } */}
          </>
        ))}
      </div>
    </Card>
  );
};

export default Tasks;
